export default {
	'total-quantity': 'Total quantity'
}